module.exports = __webpack_public_path__ + "img/support-of-icec.52c36446.png";